export const HOST = 'https://drumnickydrum-sequencer.herokuapp.com';
export const ORIGIN = 'sequencer64.com';
export const NETWORK_TIMEOUT = 5000;
export const SHARE_TEXT = 'Check%20out%20my%20new%20beat%20using%20%23Sequencer64!%20';
export const TWITTER_URL = `https://twitter.com/intent/tweet?text=${SHARE_TEXT}&url=`;
export const FACEBOOK_URL = `https://www.facebook.com/sharer/sharer.php?u=`;
